import { InvoiceStatus, OrderStatus } from "../enums";

export function isInvoiceTypeKnown(
  invoiceType: unknown,
): invoiceType is "ORDER" | "DELIVERY" {
  return invoiceType === "ORDER" || invoiceType === "DELIVERY";
}

export function getDeleteInvoiceDisabled(
  invoiceStatus: string | undefined,
  orderStatus: OrderStatus | undefined,
  invoiceType?: unknown,
): boolean {
  if (!isInvoiceTypeKnown(invoiceType)) {
    return true;
  }
  const blockedByOrder =
    orderStatus === OrderStatus.DISPATCHED ||
    orderStatus === OrderStatus.DELIVERED;
  const invoiceOk = invoiceStatus === InvoiceStatus.UNPAID;
  return blockedByOrder || !invoiceOk;
}

export function getDeleteInvoiceTooltip(
  invoiceStatus: string | undefined,
  orderStatus: OrderStatus | undefined,
  invoiceType?: unknown,
): string {
  if (!isInvoiceTypeKnown(invoiceType)) {
    return "Cannot delete: invoice type is missing";
  }
  const invoiceTypeLabel = invoiceType.toLowerCase();
  if (orderStatus === OrderStatus.DISPATCHED) {
    return "Cannot delete: order has been dispatched";
  }
  if (orderStatus === OrderStatus.DELIVERED) {
    return "Cannot delete: order has been delivered";
  }
  if (invoiceStatus === InvoiceStatus.PAID) {
    return "Cannot delete: invoice is paid";
  }
  if (invoiceStatus === InvoiceStatus.RECEIVED) {
    return "Cannot delete: invoice is received";
  }
  if (invoiceStatus !== InvoiceStatus.UNPAID) {
    return "Cannot delete: only unpaid invoices can be removed";
  }
  return `Delete ${invoiceTypeLabel} invoice`;
}
